import { trackAppcuesEvent } from "@expert/monitoring";
import { CustomerPanel } from "@expert/sales-tools";
import { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { useEligibilityPrecheck } from "@/customer-panel/hooks/useEligibilityPrecheck";
import { useSessionId } from "@/sdk";
import { RenderError } from "@/shared-utils";

import { useDigitalCompetencyListener } from "./hooks/useDigitalCompetencyListener";

export function CustomerPanelWrapper() {
    const sessionId = useSessionId();
    useDigitalCompetencyListener();
    useEligibilityPrecheck(sessionId);
    useEffect(() => {
        trackAppcuesEvent("CustomerPanelVisible", {});
    }, []);

    return (
        <ErrorBoundary fallback={<RenderError />}>
            <CustomerPanel />
        </ErrorBoundary>
    );
}
